// extracted by mini-css-extract-plugin
module.exports =  {"item":"_2787e5dfdf--item--ihWga"};